module.exports = __webpack_public_path__ + "img/yilapao1.4df175d6.jpg";